import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { sa } from '../superAdminUi';

// The shared frame for the Super Admin modals: a centred white card with a rounded `sa.radius.lg`
// body, a subtle overlay and a titled header with a close affordance — the approved Figma modal
// look. `width` lets each caller keep its own dialog width; `titleId` wires aria-labelledby;
// `accent` paints the design's coloured top border (teal confirm, pink error, etc.) when given.
function ModalShell({ open, onClose, title, width = { xs: '95%', sm: 480 }, titleId, accent, children }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby={titleId}
      sx={{ '& .MuiBackdrop-root': { backgroundColor: 'rgba(17, 17, 17, 0.4)' } }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width,
          maxHeight: '90vh',
          overflowY: 'auto',
          scrollbarColor: `${sa.color.blue} ${sa.color.white}`,
          scrollbarWidth: 'thin',          
          bgcolor: sa.color.white,
          borderRadius: sa.radius.lg,          
          boxShadow: '0 24px 60px rgba(17, 17, 17, 0.18)',
          fontFamily: sa.font.family,
          p: 3,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2, gap: 2 }}>
          <Typography
            id={titleId}
            component='h2'
            sx={{
              fontFamily: sa.font.family,
              fontWeight: sa.font.bold,
              fontSize: '18px',
              lineHeight: 1.3,
              color: sa.color.text,              
            }}
          >
            {title}
          </Typography>
          <IconButton onClick={onClose} aria-label='Close' size='small' sx={{ mt: '-4px', mr: '-4px', color: sa.color.textGray }}>
            <CloseIcon fontSize='small' />
          </IconButton>
        </Box>
        {children}
      </Box>
    </Modal>
  );
}

ModalShell.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  titleId: PropTypes.string,
  accent: PropTypes.string,
  children: PropTypes.node,
};

export default ModalShell;
